import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AutomateDataState } from 'src/app/modules/admin/profile-management/profile-detail/automate-datastate-log/automate-datastate-model';
import { AutomateDatastateService } from 'src/app/modules/admin/profile-management/profile-detail/automate-datastate-log/automate-datastate.service';
import { ProposalHistoryPagedData, SaleAccountService } from 'src/app/modules/admin/sale-account-management/sale-account.service';
import { Page } from 'src/app/shared/models/paging/page';
import { ReturnResult } from 'src/app/shared/models/return-result';
import { IProposalHistoryRepository } from './proposal-history-repository.port';

/**
 * ## Proposal History Repository Adapter
 *
 * Infra adapter that bridges feature repository port to existing services.
 * It decides query route by key shape:
 * - email-like => query by client email
 * - otherwise => query by client/account id
 */
@Injectable()
export class ProposalHistoryRepositoryAdapter implements IProposalHistoryRepository {
  constructor(
    private saleAccountService: SaleAccountService,
    private automateDatastateService: AutomateDatastateService,
  ) {}

  /** Routes paged history request to matching API endpoint based on `accountId` format. */
  getProposalHistoryPaged(
    accountId: string,
    page: Page,
  ): Observable<ReturnResult<ProposalHistoryPagedData<any>>> {
    if ((accountId || '').includes('@')) {
      return this.saleAccountService.GetAllProposalHistoryByClientEmail(accountId, page);
    }
    return this.saleAccountService.GetAllProposalHistoryByClientId(accountId, page);
  }

  /** Fetches opportunity stage definitions used by summary/filter UI. */
  getOpportunityStages(): Observable<ReturnResult<AutomateDataState[]>> {
    return this.automateDatastateService.getOpportunityDataState();
  }
}
